import { DRAFT_CLOSE_ACTION, DRAFT_CREATE_ACTION } from './Draft.constants'

export function isDraftSaveAction(action) {
  return action === DRAFT_CLOSE_ACTION.saveDraft
}

export function isDraftDiscardAction(action) {
  return action === DRAFT_CLOSE_ACTION.discardDraft
}

export function isDraftOpenAction(action) {
  return action === DRAFT_CREATE_ACTION.openDraft
}

export function isDraftCreateNewAction(action) {
  return action === DRAFT_CREATE_ACTION.createNew
}
